import { render, staticRenderFns } from "./quote-builder-organization.vue?vue&type=template&id=707d879c&"
import script from "./quote-builder-organization.vue?vue&type=script&lang=js&"
export * from "./quote-builder-organization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports